import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from 'src/components/details/sub-category-details/AppDetails'

// helpers
import Axios from 'src/helpers/axios'

const SubCategoryDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [subCategoryDetails, setSubCategoryDetails] = useState('')

  const handleCardHeaderButton = () => {
    navigate(`/products/sub-category/edit/${id}`)
    window.location.reload();
  }

  useEffect(() => {
    fetchSubCategoryDetails()
  }, [id]);

  const fetchSubCategoryDetails = () => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/categories/sub/id/${id}`,
    })
      .then(({ data }) => {
        setSubCategoryDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <AppCard
      className='mt-4 mb-4'
      headerTitle={
        <AppCardHeader
          headerTitle={<h4>Sub Category Details</h4>}
          headerButton="Edit"
          handleCardHeaderButton={handleCardHeaderButton}
        />
      }
      bodyContent={
        <AppDetails
          subCategoryDetails={subCategoryDetails}
        />
      }
    />
  )
}

export default SubCategoryDetails
